module.exports = __webpack_public_path__ + "static/media/france.fd1091c1.svg";